import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../../../constants/PublicVariables";
import { SPEED_TEST_LINK } from "../../../../constants/Constants";
import { setIsCallSettingDrawerOpen } from "../../../../reducers/common-reducer";
import { goToPlayStore } from "../../../../shared/utility";
import { isCallSettingAvailable, showHideCallSettingButton } from "./CallSettingUtils";
import mediaDeviceService from "../../../../services/mediaDeviceService";

const CallSettings = () => {
    const dispatch = useDispatch();
    const { isRoomConnected, isCallSettingDrawerOpen } = useSelector((state) => state.commonReducer);
    const { isStartCallSettingLoader } = useSelector((state) => state.callSetting);
    const localisedValues = useLanguageChange();

    const speedTest = () => {
        window.open(SPEED_TEST_LINK, "_blank");
    };

    const resetCallSettingScroll = () => {
        const callSettingModalElement = document.getElementById("call-settings-sidebar");
        const scrollDivs = callSettingModalElement?.querySelectorAll(".call-settings-scroll");
        if (scrollDivs?.length > 0) {
            scrollDivs.forEach((dom) => {
                dom.scrollTop = 0; // reset scroll
            });
        }
    };

    useEffect(() => {
        if (isCallSettingDrawerOpen && !isStartCallSettingLoader) {
            resetCallSettingScroll();
        }
    }, [isCallSettingDrawerOpen, isStartCallSettingLoader]);

    useEffect(() => {
        const callSettingModalElement = document.getElementById("call-settings-sidebar");

        const resetCallSettingModal = () => {
            // It stops the media stream, removes the video element's source, and sets the media stream and video element to null. It also stops the mic test.
            mediaDeviceService.resetMediaDeviceService();
            resetCallSettingScroll();
            const callSettingTabButton = callSettingModalElement.querySelector('[data-bs-target="#call-settings"]');
            if (callSettingTabButton) {
                callSettingTabButton.click();
            }
        };

        callSettingModalElement?.addEventListener("hide.bs.modal", resetCallSettingModal);

        return () => {
            callSettingModalElement?.removeEventListener("hide.bs.modal", resetCallSettingModal);
        };
    }, []);

    useEffect(() => {
        const handleClick = (e) => {
            if (isRoomConnected || (!PublicVariables.isMobile && GLOBAL_MEETING_DATA.isGuest)) {
                e.preventDefault();
                document.getElementById("callSettingsDrawerDiv")?.click();
                dispatch(setIsCallSettingDrawerOpen(true));
            }
        };

        const settingsDropdown = document.querySelector("#settings-dropdown");
        if (settingsDropdown) {
            settingsDropdown.addEventListener("show.bs.dropdown", handleClick);
        }

        return () => settingsDropdown?.removeEventListener("show.bs.dropdown", handleClick);
    }, [isRoomConnected]);

    return (
        <>
            {showHideCallSettingButton() && (
                <div className='topbar-button topbar-dropdown'>
                    <div className='dropdown custom-dropdown button custom-tooltip tooltip-auto-width m-hide'>
                        <button
                            className='btn dropdown-toggle triangle-none topbar-btn'
                            type='button'
                            id='settings-dropdown'
                            data-bs-toggle={"dropdown"}
                            aria-expanded='false'
                        >
                            <span className='for-icon icon-setting'></span>
                        </button>
                        <div className='dropdown-menu right' aria-labelledby='settings-dropdown' id='settings-dropdown-div'>
                            <div className='dropdown-menu-in'>
                                <ul>
                                    {isCallSettingAvailable() && (
                                        <li>
                                            <div
                                                className='dropdown-item-div'
                                                onClick={() => dispatch(setIsCallSettingDrawerOpen(true))}
                                                onKeyDown={() => {}}
                                            >
                                                <button
                                                    className='dropdown-item'
                                                    id='callSettingsDrawerDiv'
                                                    data-bs-toggle='modal'
                                                    data-bs-target='#call-settings-sidebar'
                                                >
                                                    {localisedValues["settings"]}
                                                </button>
                                            </div>
                                        </li>
                                    )}
                                    {GLOBAL_MEETING_DATA.isAgent && !isRoomConnected && (
                                        <li>
                                            <div className='dropdown-item-div'>
                                                <button className='dropdown-item' onClick={speedTest}>
                                                    {localisedValues["speed_test"]}
                                                </button>
                                            </div>
                                        </li>
                                    )}

                                    {PublicVariables.isMobile && !isRoomConnected && (
                                        <li>
                                            <div className='dropdown-item-div'>
                                                <button className='dropdown-item' onClick={goToPlayStore}>
                                                    {localisedValues["try_our_mobile_app"]}
                                                </button>
                                            </div>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className='custom-tooltip-content text-nowrap'>
                            <div className='custom-tooltip-in'>
                                <p>{localisedValues["settings"]}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CallSettings;
